import { useState } from "react";
import { positiveInt } from "../../regex/REGEX";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from "react-tooltip";
import "./textInput.css";
import { calculateEstimations } from "../domains/domain-utils";
import { replaceAt } from "../../util/util";
import React from "react";


function NKInput({
    domains,
    n,
    k,
    updateStateField,
}) {
    const [isNValid, setNValid] = useState(true);
    const [getNInputValue, setNInputValue] = useState("");
    const [getNInvalidInputMessage, setNInvalidInputMessage] = useState("");
    const [isKValid, setKValid] = useState(true);
    const [getKInputValue, setKInputValue] = useState("");
    const [getKInvalidInputMessage, setKInvalidInputMessage] = useState("");

    const getNextEstimation = (field, newValue, domainIndex) => {
        if (field === "grid_root") {
            return calculateEstimations(newValue, k + 1, domainIndex, domains);
        } else if (field === "grid_level") {
            return calculateEstimations(n, newValue, domainIndex, domains);
        }
    }

    const noBigDomains = (field, value,) => {
        if (getNextEstimation(field, value, 0).resolution > 0.5) {
            return true;
        }
        return false;
    }

    const handleNChange = (input) => {
        let value = input.target.value;
        const allowRegex = /^[0-9]$/;
        if (allowRegex) {
            // remove any not allowed characters
            for (let i = 0; i < value.length; i++) {
                if (!value.charAt(i).match(allowRegex)) {
                    value = replaceAt(value, i, "")
                    i-- //compensate index for removed char
                }
            }
        }

        const noBigDomain = noBigDomains("grid_root", parseInt(value));
        if (value.match(positiveInt) && noBigDomain) {
            setNValid(true);
            updateStateField("grid_root", parseInt(value))
        } else {
            /*
            if the input is not valid the input field will display the getInputValue instead of the state value
            this is to avoid having the state variable be set to an invalid value and also still allow input of invalid values
            blocking any invalid input leads to bad UX
            */
            setNInputValue(value || "");
            setNValid(false);
            if (noBigDomain) {
                setNInvalidInputMessage("not a valid input");
            } else {
                setNInvalidInputMessage("root domain resolution has to be > 500m")
            }
        }
    };

    const handleKChange = (input) => {
        let value = input.target.value;
        const allowRegex = /^[0-9]$/;
        if (allowRegex) {
            // remove any not allowed characters
            for (let i = 0; i < value.length; i++) {
                if (!value.charAt(i).match(allowRegex)) {
                    value = replaceAt(value, i, "")
                    i-- //compensate index for removed char
                }
            }
        }

        const noBigDomain = noBigDomains("grid_level", parseInt(value));
        if (value.match(positiveInt) && noBigDomain) {
            setKValid(true);
            updateStateField("grid_level", parseInt(value) - 1);
        } else {
            /*
            if the input is not valid the input field will display the getInputValue instead of the state value
            this is to avoid having the state variable be set to a invalid value and also still allow input of invalid values
            blocking any invalid input leads to bad UX
            */
            setKInputValue(value || "");
            setKValid(false);
            if (noBigDomain) {
                setKInvalidInputMessage("not a valid input");
            } else {
                setKInvalidInputMessage("root domain resolution has to be > 500m")
            }
        }
    };

    return (
        <React.Fragment>
            <div className={"input-container"}>
                <Tooltip id={"info-tooltip"} />
                <div className={"label-container"}>
                    <p>n</p>
                    <IoInformationCircleOutline
                        data-tooltip-id={"info-tooltip"}
                        data-tooltip-place={"right"}
                        data-tooltip-content={"n value of synthetic base grid RnBk"}
                    />
                </div>
                <input
                    style={isNValid ? null : { border: "1px solid var(--warning-color)" }}
                    value={
                        isNValid ? n : getNInputValue
                    }
                    type={"text"}
                    className="text-input"
                    onChange={handleNChange}
                    placeholder={"n"}
                />
                {!isNValid && (
                    <p className={"invalid-input-message"}>{getNInvalidInputMessage}</p>
                )}
            </div>
            <div className={"input-container"}>
                <Tooltip id={"info-tooltip"} />
                <div className={"label-container"}>
                    <p>k</p>
                    <IoInformationCircleOutline
                        data-tooltip-id={"info-tooltip"}
                        data-tooltip-place={"right"}
                        data-tooltip-content={"k value of a synthetic base grid RnBk"}
                    />
                </div>
                <input
                    style={isKValid ? null : { border: "1px solid var(--warning-color)" }}
                    value={
                        isKValid ? k + 1 : getKInputValue
                    }
                    type={"text"}
                    className="text-input"
                    onChange={handleKChange}
                    placeholder={"k"}
                />
                {!isKValid && (
                    <p className={"invalid-input-message"}>{getKInvalidInputMessage}</p>
                )}
            </div>
        </React.Fragment>
    );
}

export default NKInput;
